var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-overlay',{attrs:{"absolute":true,"color":"black","opacity":"0.6","value":"true","z-index":"-0"}},[_c('a-login-form'),_c('a-forgot-password')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }